import Gengar, { Image as GengarPreview } from './gengar';
import Hays from './hays/Hays';

export default [
  {
    key: 'gengar',
    name: 'Gengar',
    component: Gengar,
    preview: GengarPreview,
  },
  {
    key: 'hays',
    name: 'Hays',
    component: Hays,
    preview: GengarPreview,
  },
];
